import { User } from "types";
import Header from "./Header";
import Footer from "./Footer";
import Menu from "./Menu";
import styles from "./Layout.module.css";

interface LayoutProps extends React.PropsWithChildren {
  user?: User;
  onSignOut(): void;
}

const Layout: React.FC<LayoutProps> = ({ user, children, onSignOut }) => (
  <div className={styles.container}>
    <Menu onSignOut={onSignOut} />
    <main className={styles.main}>
      <Header user={user} />
      {children}
      <Footer />
    </main>
  </div>
);

export { Layout };
